"use client";

import * as React from "react";
import type { DateRange } from "react-day-picker";
import { cn } from "@/utils/utils";
import { Calendar } from "./calendar";

export type RangeCalendarProps = {
  selected?: DateRange;
  onSelect?: (range?: DateRange) => void;
  className?: string;
  numberOfMonths?: number;
} & Omit<
  React.ComponentProps<typeof Calendar>,
  "mode" | "selected" | "onSelect" | "className" | "numberOfMonths"
>;

/**
 * RangeCalendar
 * - Two-month (configurable) range selection built on top of the shared Calendar wrapper.
 * - Forwards most Calendar props while forcing mode="range".
 */
export function RangeCalendar({
  selected,
  onSelect,
  className,
  numberOfMonths = 2,
  ...props
}: RangeCalendarProps) {
  return (
    <Calendar
      mode="range"
      selected={selected as any}
      onSelect={onSelect as any}
      numberOfMonths={numberOfMonths}
      pagedNavigation
      className={cn("p-3", className)}
      {...props}
    />
  );
}

export default RangeCalendar;